import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import type { CustomerDto } from "@yalana/contracts";
import { RouteError } from "../../shared/components/RouteError";
import { RoutePending } from "../../shared/components/RoutePending";
import { customersQueries } from "../../shared/queries/customers.queries";

export const Route = createFileRoute("/app/c/$customerSlug")({
  beforeLoad: async ({ params, context }) => {
    const auth = context.auth;
    if (!auth.loading && !auth.user) {
      throw redirect({ to: "/login" });
    }
    if (auth.user) {
      const customers = await context.queryClient.ensureQueryData(
        customersQueries.list(),
      );
      const customer = customers.find((t) => t.slug === params.customerSlug);
      if (!customer) {
        throw redirect({ to: "/" });
      }
      return { customer };
    }
  },
  component: CustomerLayout,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});

function CustomerLayout() {
  const context = Route.useRouteContext();

  const customer =
    "customer" in context
      ? (context as { customer: CustomerDto }).customer
      : null;

  if (!customer) return <RoutePending />;

  return <Outlet />;
}
